/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    ApiEvent,
    ApiEventFromJSON,
    ApiEventToJSON,
} from '../models';

export interface FindEventByIdRequest {
    eventId: number;
}

/**
 * 
 */
export class EventsApi extends runtime.BaseAPI {

    /**
     * Fetches event by id
     */
    async findEventByIdRaw(requestParameters: FindEventByIdRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ApiEvent>> {
        if (requestParameters.eventId === null || requestParameters.eventId === undefined) {
            throw new runtime.RequiredError('eventId','Required parameter requestParameters.eventId was null or undefined when calling findEventById.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read", "write"]);
        }

        const response = await this.request({
            path: `/v1/events/{eventId}`.replace(`{${"eventId"}}`, encodeURIComponent(String(requestParameters.eventId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiEventFromJSON(jsonValue));
    }

    /**
     * Fetches event by id
     */
    async findEventById(requestParameters: FindEventByIdRequest, initOverrides?: RequestInit): Promise<ApiEvent> {
        const response = await this.findEventByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
